import React, { createContext, useContext } from 'react';

const NotificationCenterContext = createContext();

export const useNotificationCenter = () => {
  const context = useContext(NotificationCenterContext);
  if (!context) {
    throw new Error('useNotificationCenter must be used within NotificationCenterProvider');
  }
  return context;
};

export const NotificationCenterProvider = ({ children }) => {
  const openNotificationCenter = () => {
    window.dispatchEvent(new CustomEvent('notifications:open'));
  };

  return (
    <NotificationCenterContext.Provider value={{ openNotificationCenter }}>
      {children}
    </NotificationCenterContext.Provider>
  );
};
